import { AuthDenialCode } from '@gearbelt/global';
import { create } from 'zustand';

interface AuthDenialStore {
  deniedReason: AuthDenialCode | null;
  setDeniedReason: (deniedReason: AuthDenialCode | null) => void;
  hasNoGearbeltRoleAnywhere: boolean;
  markNoGearbeltRoleAnywhere: () => void;
}

/**
 * Not persisted: a stale denial would greet the user on reload. A store rather
 * than React state because the ky hook that writes it runs outside React.
 */
export const useAuthDenialStore = create<AuthDenialStore>((set) => ({
  deniedReason: null,
  setDeniedReason: (deniedReason) => set({ deniedReason }),
  hasNoGearbeltRoleAnywhere: false,
  markNoGearbeltRoleAnywhere: () => set({ hasNoGearbeltRoleAnywhere: true }),
}));
